<template>
  <span v-if="productOffer.name">{{productOffer.name}}</span>
  <span v-else-if="productOffer.codename">{{productOffer.codename}}</span>
</template>

<script>
export default {
  name: 'product-offer-item',
  props: ['productOffer']
}
</script>



// WEBPACK FOOTER //
// src/components/ProductOfferItem.vue